import React from 'react';
import './App.scss';
import { ThemeProvider, DataProvider, translateNamespace, callApi, prepareInlineAdapter, PluginProvider, AuthProvider, 
    getBaseUrl, getCurrentPage, PortalConfig } from '@cloudpremise/portal_core';
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";
import { I18nextProvider, useTranslation } from 'react-i18next';
import { getI18nextInstance } from './i18n/i18n';
import { BrowserRouter, MemoryRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import CustomRouter from "./components/CustomRouter";
import PluginManager from "./plugins";
import Config from "./Config";
import CircularProgress from '@mui/material/CircularProgress';
prepareInlineAdapter();

declare const window: Window & typeof globalThis & {
    inlineApexAdaptor: any,
    jsforce: any,
}
const history = createBrowserHistory();
const cdnUrl = Config.getCdnUrl();
const bgImage = cdnUrl + "/assets/img/lead2.jpg";

function App() {
    const dataProvider = process.env.REACT_APP_DATA_PROVIDER;
    const [controller, dispatch] = useMaterialUIController();
    const { config, loadingConfig } = controller;
    const i18n = getI18nextInstance();
    document.documentElement.lang = i18n.language;
    const { t } = useTranslation();
    const page = getCurrentPage();
    const basename = getBaseUrl();
    if(window.location.pathname !== page){
        history.push(page+window.location.search+window.location.hash);
    }
    React.useEffect(() => {
        loadData();
    }, []);

    function loadData(){
        const portalConfigRecord: PortalConfig = {
            sObjectTypeName: 'Config',
            url: "/v1/portal/config",
        }
        callApi(dataProvider, portalConfigRecord).then((response: any) => {
            if(response && Array.isArray(response?.result)){
                if(response.result.length > 0){
                    const config = translateNamespace(response.result[0]);
                    PluginManager.setConfiguredPlugins(config.plugins);
                    dispatch({value: {config: config, loadingConfig: false}, type: "UPDATE_STATE"});
                }else{
                    dispatch({value: {loadingConfig: false}, type: "UPDATE_STATE"});
                }
            }else{
                dispatch({value: {loadingConfig: false}, type: "UPDATE_STATE"});
            }
        }).catch((err) => {
            console.log(err);
        });
    }
    function getDefaultTheme(){
        let theme = localStorage.getItem("frontend_theme");
        if( theme === null){
            theme = process.env.REACT_APP_THEME;
        }
        return theme;
    }
    
    const ReactRouter = process.env.NODE_ENV === "development" ? MemoryRouter : BrowserRouter;
    let routerProps = {
        basename: basename
    };
    if(process.env.NODE_ENV === "development"){
        routerProps['initialEntries'] = [page];
    }
    return (
        <ThemeProvider theme={getDefaultTheme()}>
            <DataProvider type={dataProvider}>
                <I18nextProvider i18n={i18n}>
                    {
                        config === null || loadingConfig ?
                            <div className="splash-screen-container" style={{backgroundImage: "url("+bgImage+")",backgroundSize: "cover"}}>
                                <div className="splash-screen">
                                    <CircularProgress color="info" size="60px" />
                                </div>
                            </div>
                        :
                            <PluginProvider pluginManager={PluginManager}>
                                <ReactRouter {...routerProps}>
                                    <AuthProvider authTypes={["link", "microsoft","salesforce"]}>
                                        <div className="slds-scope slds-is-relative App">
                                            <div className="main-container" id="global_wrapper">
                                                <CustomRouter page={page} basename={basename} history={history} />
                                            </div>
                                        </div>
                                    </AuthProvider>
                                    {PluginManager.render()}
                                </ReactRouter>
                            </PluginProvider>
                    }
                </I18nextProvider>
            </DataProvider>
        </ThemeProvider>
    );
}

export default App;
